<template>
  <div>
    <div id="three"></div>
  </div>
</template>

<script>
  import iLoveU from "./ivu"
  export default {
    name: "ILoveU",
    mounted () {
      iLoveU.init()
    }
  }
</script>

<style scoped>
  #container{
    position: absolute;
    top:0;
    left: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    margin: 0;
  }
</style>
